import { Box, makeStyles } from '@material-ui/core';
import Send from '@material-ui/icons/Send';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '40px',
    width: '40px',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    cursor: 'pointer',
  },
  icon: {
    height: '24px',
    width: '24px',
    color: 'white',
    paddingLeft: '3px',
  },
  disabledStyle: {
    backgroundColor: theme.b2chatgray[600],
  },
}));

const SendIcon: React.FC<{
  handleSendMessage: () => void;
  disabled?: boolean;
}> = ({ handleSendMessage, disabled }) => {
  const { root, icon, disabledStyle } = useStyles();
  return (
    <Box className={`${root} ${disabled ? disabledStyle : ''}`}>
      <Send className={icon} onClick={handleSendMessage} />
    </Box>
  );
};

export default SendIcon;
